module.exports = __webpack_public_path__ + "static/img/pointscenter@2x.2d01004a.png";